// extracted by mini-css-extract-plugin
module.exports = {"container":"_1mCrz-1KL3Qnreh6vJfAkT"};